if (!customElements.get('lsg-flavor-characteristic')) {
  class LSGFlavorCharacteristic extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        progressBar: 'js-progress-bar'
      };

      this.elements = {
        progressBar: this.querySelector(`.${this.classes.progressBar}`)
      };

      this.state = {
        targetWidth: '0',
        observer: null
      };

      // Bind methods
      this.animateProgress = this.animateProgress.bind(this);
      this.setupIntersectionObserver = this.setupIntersectionObserver.bind(this);
    }

    /**
     * Lifecycle method called when element is added to DOM
     * Initializes progress bar and sets up animation if enabled
     */
    connectedCallback() {
      const progressWidth = this.dataset.animate;
      if (!this.elements.progressBar || !progressWidth) return;

      this.state.targetWidth = progressWidth;
      this.setupIntersectionObserver();
    }

    /**
     * Lifecycle method called when element is removed from DOM
     * Cleans up intersection observer
     */
    disconnectedCallback() {
      if (this.state.observer) {
        this.state.observer.disconnect();
      }
    }

    /**
     * Sets up intersection observer to trigger animation when element is 70% visible from bottom
     */
    setupIntersectionObserver() {
      const options = {
        threshold: 1, // Trigger when 70% visible
        rootMargin: '0px 0px -5% 0px' // Offset from bottom of viewport
      };

      this.state.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateProgress();
            this.state.observer.disconnect();
          }
        });
      }, options);

      this.state.observer.observe(this);
    }

    /**
     * Animates the progress bar to its target width
     */
    animateProgress() {
      if (!this.elements.progressBar) return;
      
      this.elements.progressBar.style.width = `${this.state.targetWidth}%`;
    }
  }

  customElements.define('lsg-flavor-characteristic', LSGFlavorCharacteristic);
}